<!--TODO: BEM-->
<div class="style-helper__container" [ngClass]="status()">
  <div class="border__container"></div>
  <div class="content__container">
    <ng-content/>
  </div>
</div>

